import { Modal } from '../Modal';
import { StatusUpdateProps } from './MerchDesigner';

interface SubmittingModalProps {
	statusUpdate?: StatusUpdateProps;
}

export function SubmittingModal({ statusUpdate }: SubmittingModalProps) {
	return <Modal open={!!statusUpdate} loading loadingTitle={statusUpdate?.title} />;
}
